import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgModelBrowser = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_302_6491)",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_302_6491",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 25,
			children: /* @__PURE__ */ _jsx("rect", {
				y: .218994,
				width: 24,
				height: 24,
				fill: "currentColor"
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_302_6491)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M11.35 19.6382V12.5997L5.39998 9.15549V16.021C5.39998 16.0722 5.41281 16.1202 5.43848 16.1652C5.46414 16.2101 5.50256 16.2485 5.55373 16.2805L11.35 19.6382ZM12.65 19.6382L18.4462 16.3055C18.4974 16.2735 18.5358 16.2351 18.5615 16.1902C18.5871 16.1452 18.6 16.0972 18.6 16.046V9.18049L12.65 12.5997V19.6382ZM12 11.4575L18.125 7.93824L12.1287 4.50549C12.0776 4.47349 12.0263 4.45749 11.975 4.45749C11.9236 4.45749 11.8724 4.47349 11.8212 4.50549L5.87498 7.93824L12 11.4575ZM4.90398 17.4227C4.65098 17.2772 4.45373 17.0826 4.31223 16.8387C4.17073 16.5947 4.09998 16.3272 4.09998 16.0362V8.40174C4.09998 8.11074 4.17073 7.84324 4.31223 7.59924C4.45373 7.35541 4.65098 7.16074 4.90398 7.01524L11.1712 3.38824C11.4224 3.24074 11.6986 3.16699 12 3.16699C12.3013 3.16699 12.5776 3.24074 12.8287 3.38824L19.096 7.01524C19.349 7.16074 19.5462 7.35541 19.6877 7.59924C19.8292 7.84324 19.9 8.11074 19.9 8.40174V16.0362C19.9 16.3272 19.8292 16.5947 19.6877 16.8387C19.5462 17.0826 19.349 17.2772 19.096 17.4227L12.8037 21.0747C12.5504 21.2222 12.2819 21.296 11.9982 21.296C11.7147 21.296 11.4474 21.2222 11.1962 21.0747L4.90398 17.4227Z",
				fill: "currentColor"
			})
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_302_6491",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "currentColor",
			transform: "translate(0 0.218994)"
		})
	}) })]
});
export default SvgModelBrowser;
